// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ClientType, ClientTypeEnum } from './ClientType';
import { Themes } from './ThemesEnum';
export class ConnectionInfoItem {
    constructor() {
        this.registrationLinks = [];
        this.allowPasswordPreview = false;
        this.allowSavePassword = false;
        this.PrimaryBranding = false;
    }
    GetTitle() {
        const clientType = ClientType.getClientType();
        switch (clientType) {
            case ClientTypeEnum.WebDesktop:
                return this.BrandingWebName;
            case ClientTypeEnum.WebTvTradingPlatform:
                return this.BrandingTVName;
        }
        return null;
    }
    GetWebHeaderUrl(theme) {
        const headerRelativeUrl = this.GetWebHeader(theme);
        if (!this.IsValidHeader(headerRelativeUrl))
            return null;
        const filePrefix = this.GetWebHeaderFilePrefix(theme);
        return this.getLocalFileName(headerRelativeUrl, filePrefix);
    }
    GetLoginBannerUrl(theme) {
        const bannerRelativeUrl = this.GetLoginBanner(theme);
        if (!this.IsValidHeader(bannerRelativeUrl))
            return null;
        const filePrefix = this.GetLoginBannerFilePrefix(theme);
        return this.getLocalFileName(bannerRelativeUrl, filePrefix);
    }
    GetFaviconUrl() {
        const bannerRelativeUrl = this.GetFavicon();
        if (!this.IsValidHeader(bannerRelativeUrl))
            return null;
        const filePrefix = this.GetFaviconFilePrefix();
        return this.getLocalFileName(bannerRelativeUrl, filePrefix);
    }
    GetSplashScreenUrl() {
        const bannerRelativeUrl = this.GetSplashScreen();
        if (!this.IsValidHeader(bannerRelativeUrl))
            return null;
        const filePrefix = this.GetSplashScreenFilePrefix();
        return this.getLocalFileName(bannerRelativeUrl, filePrefix);
    }
    GetWebHeader(theme) {
        const clientType = ClientType.getClientType();
        switch (clientType) {
            case ClientTypeEnum.WebDesktop:
                return theme === Themes.Light ? this.BrandingWebHeaderLightTheme : this.BrandingWebHeader;
            case ClientTypeEnum.WebTvTradingPlatform:
                return '';
        }
        return '';
    }
    GetWebHeaderFilePrefix(theme) {
        const clientType = ClientType.getClientType();
        switch (clientType) {
            case ClientTypeEnum.WebDesktop:
                return theme === Themes.Light ? 'BrandingWebHeaderLightTheme' : 'BrandingWebHeader';
            case ClientTypeEnum.WebTvTradingPlatform:
                return '';
        }
        return '';
    }
    GetLoginBanner(theme) {
        const clientType = ClientType.getClientType();
        switch (clientType) {
            case ClientTypeEnum.WebDesktop:
                return theme === Themes.Light ? this.BrandingWebLoginBannerLightTheme : this.BrandingWebLoginBanner;
            case ClientTypeEnum.WebTvTradingPlatform:
                return this.BrandingTVLogo;
            case ClientTypeEnum.WebMobile:
                return this.BrandingWMLoginBanner;
        }
        return '';
    }
    GetLoginBannerFilePrefix(theme) {
        const clientType = ClientType.getClientType();
        switch (clientType) {
            case ClientTypeEnum.WebDesktop:
                return theme === Themes.Light ? 'BrandingWebLoginBannerLightTheme' : 'BrandingWebLoginBanner';
            case ClientTypeEnum.WebTvTradingPlatform:
                return 'BrandingTVLogo';
            case ClientTypeEnum.WebMobile:
                return 'BrandingWMLoginBanner';
        }
        return '';
    }
    GetFavicon() {
        const clientType = ClientType.getClientType();
        switch (clientType) {
            case ClientTypeEnum.WebDesktop:
                return this.BrandingWebFavicon;
            case ClientTypeEnum.WebTvTradingPlatform:
                return this.BrandingTVFavicon;
            case ClientTypeEnum.WebMobile:
                return this.BrandingWMFavicon;
        }
        return '';
    }
    GetFaviconFilePrefix() {
        const clientType = ClientType.getClientType();
        switch (clientType) {
            case ClientTypeEnum.WebDesktop:
                return 'BrandingWebFavicon';
            case ClientTypeEnum.WebTvTradingPlatform:
                return 'BrandingTVFavicon';
            case ClientTypeEnum.WebMobile:
                return 'BrandingWMFavicon';
        }
        return '';
    }
    GetSplashScreen() {
        const clientType = ClientType.getClientType();
        switch (clientType) {
            case ClientTypeEnum.WebDesktop:
                return this.BrandingWebSplashScreen;
            case ClientTypeEnum.WebMobile:
                return this.BrandingWMBackgroundImage;
        }
        return '';
    }
    GetSplashScreenFilePrefix() {
        const clientType = ClientType.getClientType();
        switch (clientType) {
            case ClientTypeEnum.WebDesktop:
                return 'BrandingWebSplashScreen';
            case ClientTypeEnum.WebMobile:
                return 'BrandingWMBackgroundImage';
        }
        return '';
    }
    getLocalFileName(path, propName) {
        const directoryToCreate = `brandingImgs/${this.brandingKey}/`;
        return `${directoryToCreate}${propName}_${path.match(/\/([^/]+\.\w+)$/)[1]}`;
    }
    IsValidHeader(header) {
        return !isNullOrUndefined(header) && isValidString(header);
    }
}
export class WebMobileManifestInfo {
    static isComplete(data) {
        return WebMobileManifestInfo.requiredFields.every((field) => isValidString(data[field]));
    }
    static createIfNotEmpty(data) {
        return WebMobileManifestInfo.isComplete(data) ? Object.assign(new WebMobileManifestInfo(), data) : null;
    }
}
WebMobileManifestInfo.requiredFields = [
    'appName',
    'shortAppName',
    'description',
    'icon32',
    'icon32Hash',
    'icon48',
    'icon48Hash',
    'icon72',
    'icon72Hash',
    'icon96',
    'icon96Hash',
    'icon128',
    'icon128Hash',
    'icon256',
    'icon256Hash',
    'icon512',
    'icon512Hash'
];
export class DbConnectionInfo {
}
